import { useEffect, useState } from 'react';
import type { VoiceLang } from './settings';
import { listVoices, onVoicesChanged } from './tts';

/** Voice languages offered in the UI, Indonesia first, Malay second. */
export const VOICE_LANGS: Array<{ value: VoiceLang; label: string; short: string; sub: string }> = [
  { value: 'id-ID', label: 'Bahasa Indonesia', short: 'ID', sub: 'Indonesia' },
  { value: 'ms-MY', label: 'Bahasa Melayu', short: 'MY', sub: 'Malaysia' },
  { value: 'en-US', label: 'English', short: 'EN', sub: 'US · UK · SG' },
  { value: 'zh-CN', label: '中文', short: '中文', sub: '普通话' },
  { value: 'ta-IN', label: 'தமிழ்', short: 'TA', sub: 'Tamil' },
];

/** Native names for every language a comment can be spoken in (script detection included). */
const NAMES: Record<string, string> = {
  id: 'Bahasa Indonesia',
  ms: 'Bahasa Melayu',
  en: 'English',
  zh: '中文',
  ta: 'தமிழ்',
  ja: '日本語',
  ko: '한국어',
  th: 'ไทย',
  ar: 'العربية',
};

export function languageName(lang: string): string {
  return NAMES[lang.toLowerCase().split('-')[0]] ?? lang;
}

/** Device voices; re-renders when the browser finishes loading them (Chrome and Edge load late). */
export function useVoices(): SpeechSynthesisVoice[] {
  const [voices, setVoices] = useState(listVoices());
  useEffect(() => {
    const update = () => setVoices(listVoices());
    update();
    const off = onVoicesChanged(update);
    const id = window.setTimeout(update, 500);
    return () => {
      off();
      window.clearTimeout(id);
    };
  }, []);
  return voices;
}
